<template>
  <tr>
    <td>
      <EllipsisTip>{{ item.keyword }}</EllipsisTip>
    </td>
    <td class="c-text--center">
      {{ item.yearMonth | dateText('YYYY.MM') | nullToHyphen }}
    </td>
    <td class="c-text--right">
      {{ item.searchVolume | separateNumber | nullToHyphen }}
    </td>
  </tr>
</template>

<script>
import EllipsisTip from '@/components/EllipsisTip';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    EllipsisTip
  }
};
</script>
